import { call, put, takeEvery, all } from 'redux-saga/effects'
import loadDetailsTypes from './loadDetailsTypes'
import * as loadDetailsActions from './loadDetailsActions'
import LoadDetailsService from '../../services/LoadDetailService'
import notificationActions from '../notifications/notificationActions'

export function * bidOrder ({ payload }) {
  try {
    const response = yield call(LoadDetailsService.bidOrder, payload)
    yield put(loadDetailsActions.bidOrderSuccess(response.data))
    yield put(notificationActions.SendToast({ message: 'The order was bid successfully', type: 'success' }))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(loadDetailsActions.bidOrderFailure(message))
  }
}

export function * bookOrder ({ payload }) {
  try {
    yield call(LoadDetailsService.bookOrder, payload)
    yield put(loadDetailsActions.bookOrderSuccess(payload.order))
    yield put(notificationActions.SendToast({ message: 'The order was booked successfully', type: 'success' }))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(loadDetailsActions.bookOrderFailure(message))
  }
}

export function * getMapImage ({ payload }) {
  try {
    const response = yield call(LoadDetailsService.getMapImage, payload)
    yield put(loadDetailsActions.getMapImageSuccess(response.data))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(loadDetailsActions.getMapImageFailure(message))
  }
}

export function * bidOffer ({ payload }) {
  try {
    const response = yield call(LoadDetailsService.bidOffer, payload)
    yield put(loadDetailsActions.bidOfferSuccess(response.data))
    yield put(notificationActions.SendToast({ message: 'The offer was bid successfully', type: 'success' }))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(loadDetailsActions.bidOfferFailure(message))
  }
}

export function * bookOffer ({ payload }) {
  try {
    yield call(LoadDetailsService.bookOffer, payload)
    yield put(loadDetailsActions.bookOfferSuccess(payload.offer))
    yield put(notificationActions.SendToast({ message: 'The offer was booked successfully', type: 'success' }))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(loadDetailsActions.bookOfferFailure(message))
  }
}

export function * getTractorDetails ({ payload }) {
  try {
    const response = yield call(LoadDetailsService.getTractorDetails, payload)
    yield put(loadDetailsActions.getTractorDetailsSuccess(response.data))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(loadDetailsActions.getTractorDetailsFailure(message))
  }
}

export function * onBidOffer () {
  yield takeEvery(loadDetailsTypes.BID_OFFER, bidOffer)
}

export function * onBookOffer () {
  yield takeEvery(loadDetailsTypes.BOOK_OFFER, bookOffer)
}

export function * onBidOrder () {
  yield takeEvery(loadDetailsTypes.BID_ORDER, bidOrder)
}

export function * onBookOrder () {
  yield takeEvery(loadDetailsTypes.BOOK_ORDER, bookOrder)
}

export function * onGetMapImage () {
  yield takeEvery(loadDetailsTypes.GET_MAP_IMAGE, getMapImage)
}

export function * onGetTractorDetails () {
  yield takeEvery(loadDetailsTypes.GET_TRACTOR_DETAILS, getTractorDetails)
}

export function * loadDetailsSaga () {
  yield all([
    call(onBidOrder),
    call(onBookOrder),
    call(onBidOffer),
    call(onBookOffer),
    call(onGetMapImage),
    call(onGetTractorDetails)
  ])
}
